<div class="worklist-result-main-container">
    <div style="display: flex; flex-direction: column; height: 100%">
        <ag-grid-angular
            #datagrid
            class="worklist-grid ag-theme-material"
            [gridOptions]="gridOptions"
            [rowData]="items"
            (rowDataUpdated)="onRowDataUpdated($event)"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            (rowDoubleClicked)="onRowDoubleClick($event)"
            (selectionChanged)="onSelectedItemsChange($event)"
            (contextmenu)="onContextMenu($event)"
            (cellContextMenu)="onCellContextMenu($event)"
        >
        </ag-grid-angular>
        <div class="se-result-footer-container">
            <se-search-footer-toolbar
                style="flex-grow: 1"
                [selectionMetaData]="selectionMetaData"
                [items]="items"
                [unselectAllBtnClick]="unselectAllBtnClick"
                [selectionBtnClick]="selectionBtnClick"
                [removeSelectionBtnClick]="removeSelectionBtnClick"
            >
            </se-search-footer-toolbar>
            <mat-divider class="se-header-divider" [vertical]="true"></mat-divider>
            <se-search-settings
                [settingsConfig]="menuSettingsConfig"
                [settingsDataValuesList]="menuSettingsData"
                [onSaveSettings]="onSaveColumnConfig"
                [isCurrentUserAuthorized]="isCurrentUserAuthorized"
                [onResetDefaultSettings]="onResetConfigurationColumn"
                (configEntryChanged)="handleChangeConfigEntry($event)"
            >
            </se-search-settings>
        </div>
    </div>

    <div
        *ngIf="!isBusy && contextMenuButtonsData.length > 0"
        #worklistContextMenuTrigger="matMenuTrigger"
        style="visibility: hidden; position: fixed"
        [style.left]="contextMenuPosition.x"
        [style.top]="contextMenuPosition.y"
        [matMenuTriggerFor]="worklistContextMenu"
    ></div>

    <mat-menu #worklistContextMenu="matMenu"
              class="se-mat-menu"
              hasBackdrop="false"
              (clickOutside)="onClickOutsideMenu($event)">
        <div *ngFor="let buttonData of contextMenuButtonsData">
            <button *ngIf="!buttonData.hasChildren"
                    mat-menu-item
                    class="se-menu-item se-menu-button"
                    [class.se-context-menu-toolbar-button-checked]="buttonData.isToggle && buttonData.status.checked"
                    (click)="onContextMenuAction(buttonData)"
                    translate>
                {{ buttonData.actionType | translate}}
            </button>

            <button *ngIf="buttonData.hasChildren"
                    mat-menu-item
                    class="se-menu-item se-menu-button"
                    [matMenuTriggerFor]="toolbarButtonSubMenu"
                    translate>
                {{ buttonData.actionType | translate }}
            </button>
            <mat-menu #toolbarButtonSubMenu="matMenu" class="se-mat-menu">
                <div *ngFor="let childButtonData of buttonData.children">
                    <button mat-menu-item
                            class="se-menu-button"
                            [class.se-context-menu-toolbar-button-checked]="
                            childButtonData.isToggle && childButtonData.status.checked
                        "
                            (click)="onContextMenuAction(childButtonData)"
                            translate>
                        {{ childButtonData.actionType | translate}}
                    </button>
                </div>
            </mat-menu>
        </div>
    </mat-menu>
</div>

<se-modaldialog
    [buttonCancel]="false"
    [buttonOk]="true"
    [header]="'Warning' | translate"
    [visible]="showMaxSelectionDialog"
    [isWarning]="true"
    (buttonClick)="showMaxSelectionDialog = false"
    class="custom-data-dialog"
    [windowSize]="3"
>
    <div content>{{ "MaxSelectableRowWarning" | translate }} ({{ maxEcgToOpenTogether }})</div>
</se-modaldialog>
